import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const BaseCalcul = [
  'Quantite',
  'Montant',
] as const

export type BaseCalcul = typeof BaseCalcul[number]

export const BaseCalculLibelle: UnionTypeLibelle<BaseCalcul> = {
  Quantite: 'Quantite',
  Montant: 'Montant',
} as const
